import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import { Shop } from '../../../../components/Shop';
import { useCoveragesPremiums } from '../../useCoveragesForm';
import { SectionHeader } from '../SectionHeader';

import * as styles from './Header.module.css';

import type { ShopContentCommon } from '../../Shop';

export const Header: React.FC<ShopContentCommon> = ({ className, hideHeaderPremium = false, ...content }) => {
  const {
    isLoading,
    premium: { amount, amountBeforeDiscount },
  } = useCoveragesPremiums();

  return (
    <div className={className}>
      <SectionHeader className={styles.richContent}>
        <SectionHeader.Content content={content.introContent} />
      </SectionHeader>
      {hideHeaderPremium ? null : (
        <>
          <Shop.Price
            amountBeforeDiscount={amountBeforeDiscount}
            amount={amount}
            locale={content.country}
            formatLabel={(currency) => `${currency} ${content.translations.perMonth}`}
            isLoading={isLoading}
          />
        </>
      )}
      <small className={clsx(styles.conditions, textSm)}>{content.translations.headerConditions}</small>
    </div>
  );
};
